const B2B_COMMERCE_PROMOTIONAL_LINK =
  'https://www.itscope.com/loesungen/itscope-b2b-commerce/b2b-shop/'
const QUOTES_PROMOTIONAL_LINK =
  'https://www.itscope.com/loesungen/itscope-essential/digitale-angebote/'
const DEFAULT_COMMENT_LENGTH = 255

type ColadaPageableResponse<T> = {
  pageParams: number[]
  pages: T[]
}

type PageableResponse<T> = {
  totalCount: number
  pageCount: number
  items: T[]
}

type SelectOption<T> = {
  title: string
  value: T
}

enum SortDirection {
  ASC,
  DESC,
  NONE
}

enum QuoteTabs {
  REQUEST,
  QUOTE,
  ORDER,
  DOCUMENTS
}

type ViewToggle<T extends string> = {
  name: T
  icon: string
  altText: string
  label?: string
  showOnMobile: boolean
  restriction: () => boolean
  count?: {
    loadFunction: () => Promise<void | boolean>
    getter: () => boolean
  }
}

type VForm = {
  validate: () => boolean
  resetValidation: () => boolean
  reset: () => void
}

const PAGE_SIZE = 24

type CommentType = 'ORDER' | 'QUOTE'

enum Language {
  de = 'de',
  en = 'en',
  fr = 'fr',
  it = 'it',
  pl = 'pl',
  nl = 'nl',
  es = 'es'
}

const FALLBACK_LOCALE = 'en'
const supportedLocales = Object.keys(Language)
type Locale = (typeof supportedLocales)[number]

type KeyValue = { key: string; value: boolean }

interface InternalItem<T> {
  value: T
  raw: T
}

type TreeViewCategory = {
  children?: TreeViewCategory[]
  id: number
  isSelectable: boolean
  name: string
  searchTerm: string
}

export {
  B2B_COMMERCE_PROMOTIONAL_LINK,
  ColadaPageableResponse,
  CommentType,
  DEFAULT_COMMENT_LENGTH,
  FALLBACK_LOCALE,
  InternalItem,
  KeyValue,
  Language,
  Locale,
  PAGE_SIZE,
  PageableResponse,
  QUOTES_PROMOTIONAL_LINK,
  QuoteTabs,
  SelectOption,
  SortDirection,
  supportedLocales,
  TreeViewCategory,
  VForm,
  ViewToggle
}
